import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import './simple-file-upload.css';
import { FaEye } from 'react-icons/fa';

const SimpleFileUpload = ({ id, onChange, className, value, filePath, isDisabled, onViewClick }) => {
  const [fileName, setFileName] = useState(value);

  // Sync internal state with prop changes
  useEffect(() => {
    setFileName(value);
  }, [value]);

  const handleFileUpload = event => {
    setFileName(undefined);
    onChange(event);
  };

  const handleViewClick = (e) => {
    e.preventDefault();
    if (onViewClick) {
      // Use custom handler if provided
      onViewClick(filePath, fileName);
    } else {
      // Fallback to default behavior (open in new tab)
      window.open(filePath, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <div className={`file-upload-wrapper ${className}`}>
      {!isDisabled && (
      <input
        type="file"
        id={id}
        onChange={handleFileUpload}
        className={`form-control ${fileName ? 'custom-file-input' : ''}`}
      />
)}
      {/* {fileName && filePath && (
        <a href={filePath} className="file-name-overlay" target="_blank" rel="noopener noreferrer">
          {fileName}
        </a>
      )} */}

      {fileName && filePath && (
        <div className="file-display-box">
          <span className="file-name-text" title={fileName}>
            {fileName}
          </span>
          <a
            href={filePath}
            onClick={handleViewClick}
            className="eye-icon-right"
            title="View File"
            aria-label="View file"
          >
            <FaEye />
          </a>
        </div>
      )}
    </div>
  );
};

SimpleFileUpload.propTypes = {
  id: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
  value: PropTypes.string,
  filePath: PropTypes.string,
  isDisabled: PropTypes.bool,
  onViewClick: PropTypes.func, // Optional callback: (filePath, fileName) => void
};

export default SimpleFileUpload;
